import { BaseDTO } from './base-dto';
import { Organization } from './organization';
import { GenderEnum } from '../enums/gender-enum';
import { UserTypeEnum } from '../enums/user-type-enum';
import { UserRole } from './user-role';
import { UserProductLine } from './user-product-line';
import { UserMarket } from './user-market';
import { UserSalesCenter } from './user-sales-center';
import { MarketLevel } from './market-level';
import {UserMnthlyAllowance} from './user-mnthly-allowance';
import {BaseGeoLocation} from './base-geo-location';
import {UserDepot} from './user-depot';

export class User extends BaseDTO {
    Organization: Organization;
    Name: string;
    Code: string;
    Gender: GenderEnum;
    UserType: string;
    UserRole: UserRole;
    Designation: string;
    Email: string;
    Mobile: string;
    Phone: string;
    Password: string;
    JoiningDate: string;
    ResignationDate: string;
    Remarks: string;
    Image: string;
    ImageData: string;                      // not for service
    ImageType: string;
    UserProductLineList: UserProductLine[];
    UserMonthlyAllowanceList: UserMnthlyAllowance[];
    UserMarketList: UserMarket[];
    PrimaryProductLine: UserProductLine;
    UserSalesCenterList: UserSalesCenter[];
    MarketLevelHierarchy: MarketLevel[];
    Superior: User[];
    UserName: string;
    UserCode: string;
    AttendanceLocation: BaseGeoLocation;
    RxBasedUser: boolean;
    ExperiencedUser: boolean;
    UserDepotList: UserDepot[] = [];
    CreditLimit: number;
    Due: number;
    CheckCreditLimit: boolean;
    PFNumber: string;
}
